// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SplitPayment_modal__img__sRT9L {
  height: 7.5rem;
  margin-bottom: 3rem;
}

.SplitPayment_main_nav__QkwDp {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 2rem;
  padding: 0 2rem;
  background-color: var(--color-white);
  border-bottom: solid 1px var(--color-dark);
  border-radius: 1rem 1rem 0 0;
}
.SplitPayment_main_nav__QkwDp > :not(:last-child) {
  margin-right: 3rem;
}
.SplitPayment_main_nav_group__W0zgQ {
  position: relative;
}
.SplitPayment_main_nav_more__Db6Z6 {
  position: absolute;
  right: 0;
  top: 75%;
  background-color: var(--color-white);
  padding: 1.5rem;
  border-radius: 1rem;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  z-index: 5;
}
.SplitPayment_main_nav_more__Db6Z6 > :not(last-child) {
  margin-bottom: 1rem;
}
.SplitPayment_main_nav_item__sh\\+Ft {
  cursor: pointer;
  padding: 1rem 0;
  box-sizing: border-box;
  font-size: var(--default-font-small);
}
.SplitPayment_main_nav_item_active__J2674 {
  cursor: pointer;
  padding: 1rem 0;
  box-sizing: border-box;
  font-size: var(--default-font-small);
  font-weight: 700;
  color: var(--color-primary);
  border-bottom: solid 2px var(--color-primary);
}
.SplitPayment_main_nav_item__sh\\+Ft:hover, .SplitPayment_main_nav_item__sh\\+Ft:focus, .SplitPayment_main_nav_item__sh\\+Ft:focus-visible, .SplitPayment_main_nav_item__sh\\+Ft:focus-within {
  font-weight: 700;
  color: var(--color-primary);
  border-bottom: solid 2px var(--color-primary);
}
.SplitPayment_main__metrics__SvcIB {
  width: 100%;
  display: grid;
  text-align: center;
  box-sizing: border-box;
  grid-template-columns: repeat(4, 1fr);
  gap: 2rem;
}
@media only screen and (max-width: 50em) {
  .SplitPayment_main__metrics__SvcIB {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media only screen and (max-width: 37.5em) {
  .SplitPayment_main__metrics__SvcIB {
    grid-template-columns: repeat(2, 1fr);
  }
}
.SplitPayment_main__metrics_container__hb26z {
  box-sizing: border-box;
  padding: 2rem;
  width: 100%;
  background-color: var(--color-white);
  border-radius: 2rem;
}
.SplitPayment_main__metrics_lightBlue__bhqFF {
  background-color: var(--color-primary-3);
}
.SplitPayment_main__metrics_grey__\\+FPMD {
  background-color: var(--color-grey-2);
}
.SplitPayment_main__metrics_lightBlue2__o32lk {
  background-color: var(--color-primary-7);
}
.SplitPayment_main__metrics_red__wD9K0 {
  background-color: var(--color-error);
  color: var(--color-white);
}
.SplitPayment_main__metrics_green__Nb3gy {
  background-color: var(--color-success);
  color: var(--color-white);
}
.SplitPayment_main__metrics_yellow__hbDH2 {
  background-color: var(--color-yellow);
}
.SplitPayment_main__dropdowns__CLgEN {
  margin-top: 2rem;
  display: flex;
  justify-content: center;
  width: 100%;
}
@media only screen and (max-width: 43.75em) {
  .SplitPayment_main__dropdowns__CLgEN {
    flex-direction: column;
    align-items: center;
  }
}
.SplitPayment_main__dropdowns__CLgEN > :not(last-child) {
  margin-right: 2rem;
}
@media only screen and (max-width: 43.75em) {
  .SplitPayment_main__dropdowns__CLgEN > :not(last-child) {
    margin-right: none;
  }
}

.SplitPayment_threeCards__y1Xqo {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
}
@media only screen and (max-width: 37.5em) {
  .SplitPayment_threeCards__y1Xqo {
    grid-template-columns: repeat(2, 1fr);
  }
}

.SplitPayment_singleCard__Z0MDb {
  width: 100%;
  background-color: var(--color-white);
  padding: 2rem;
  border-radius: 2rem;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
}

.SplitPayment_payroll_table__uRv\\+r {
  width: 100%;
  margin-top: 3rem;
  font-size: var(--default-font-small);
}
.SplitPayment_payroll_table__uRv\\+r table {
  width: 100%;
  max-width: 100%;
  border: none;
  border-collapse: collapse;
  box-sizing: border-box;
  text-align: left;
}
.SplitPayment_payroll_table__uRv\\+r table tr {
  display: grid;
  grid-template-columns: 5% 18% 15% repeat(2, 12%) 9% 20% 10%;
  padding: 0 1rem;
  align-items: center;
}
@media only screen and (max-width: 50em) {
  .SplitPayment_payroll_table__uRv\\+r table tr {
    grid-template-columns: 15% 40% 30% 15%;
  }
}
.SplitPayment_payroll_table__uRv\\+r table th,
.SplitPayment_payroll_table__uRv\\+r table td {
  padding: 2.2rem 2rem;
}
.SplitPayment_payroll_table__uRv\\+r table th {
  font-weight: 700;
}
.SplitPayment_payroll_table__uRv\\+r table td {
  cursor: pointer;
}
.SplitPayment_payroll_table__uRv\\+r table tbody > :not(:last-child) {
  margin-bottom: 1.5rem;
}
.SplitPayment_payroll_table__uRv\\+r table tbody tr {
  background-color: var(--color-primary-3);
  border-radius: 1.3rem;
}
.SplitPayment_payroll_table__uRv\\+r table tbody tr:nth-child(even) {
  background-color: var(--color-primary-7);
  border-radius: 1.3rem;
}

.SplitPayment_status__W0HLs {
  box-sizing: border-box;
  width: 5vw;
  height: 2vw;
  color: var(--color-error);
}
.SplitPayment_status__pending__VZA8D {
  color: var(--color-yellow-3);
}
.SplitPayment_status__paid__wJtfk {
  color: var(--color-green);
}
.SplitPayment_status__failed__W2KUL {
  color: var(--color-error);
}

.SplitPayment_employee__list__oInCO {
  width: 38rem;
  margin-top: 5rem;
}
.SplitPayment_employee__list__oInCO li {
  list-style: none;
  cursor: pointer;
}
.SplitPayment_employee__list__oInCO li:hover {
  font-weight: 700;
  color: var(--color-primary);
}
.SplitPayment_employee__list_line__yLlCl {
  border-top: 1px solid var(--color-primary);
  margin: 2rem 0;
}
.SplitPayment_employee__avatar__UOfpg {
  width: 9rem;
}
.SplitPayment_employee__avatar_container__MFd72 {
  width: 10rem;
  height: 10rem;
  border-radius: 7rem;
  border: 1px solid var(--color-primary);
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 3rem 0;
}
.SplitPayment_employee__details__hmbvB {
  width: 38rem;
}
.SplitPayment_employee__editButton__T6jI4 {
  position: relative;
  right: 17rem;
  display: flex;
  font-size: 2.5rem;
  align-items: center;
  cursor: pointer;
}
.SplitPayment_employee__editButton__T6jI4 > :not(:last-child) {
  margin-right: 1rem;
}
.SplitPayment_employee__terminate__26-y1 {
  display: flex;
  flex-direction: column;
  width: 38rem;
}
.SplitPayment_employee__terminate__26-y1 > :not(:last-child) {
  margin-bottom: 1rem;
}
.SplitPayment_employee_table__0hPLy {
  width: 100%;
  margin-top: 3rem;
  font-size: var(--default-font-small);
}
.SplitPayment_employee_table__0hPLy table {
  width: 100%;
  max-width: 100%;
  border: none;
  border-collapse: collapse;
  box-sizing: border-box;
  text-align: left;
}
.SplitPayment_employee_table__0hPLy table tr {
  display: grid;
  grid-template-columns: 16% repeat(3, 15%) 15% 10% 10% 5% 15%;
  padding: 0 1rem;
  align-items: center;
}
@media only screen and (max-width: 50em) {
  .SplitPayment_employee_table__0hPLy table tr {
    grid-template-columns: repeat(2, 40%) 20%;
  }
}
.SplitPayment_employee_table__0hPLy table th,
.SplitPayment_employee_table__0hPLy table td {
  padding: 2.2rem 1rem;
}
.SplitPayment_employee_table__0hPLy table th {
  font-weight: 700;
}
.SplitPayment_employee_table__0hPLy table td {
  cursor: pointer;
}
.SplitPayment_employee_table__0hPLy table tbody > :not(:last-child) {
  margin-bottom: 1.5rem;
}
.SplitPayment_employee_table__0hPLy table tbody tr {
  background-color: var(--color-primary-3);
  border-radius: 1.3rem;
}
.SplitPayment_employee_table__0hPLy table tbody tr:nth-child(even) {
  background-color: var(--color-primary-7);
  border-radius: 1.3rem;
}
.SplitPayment_employee_table__0hPLy table tbody tr > :last-child {
  font-weight: 700;
}

.SplitPayment_crumbs__5XKYy {
  display: flex;
  margin-top: 2rem;
  margin-bottom: 1rem;
}
.SplitPayment_crumbs__5XKYy > :not(:last-child) {
  margin-right: 2rem;
}
.SplitPayment_crumbs__main__6XoJH {
  content: "";
  height: 2rem;
  width: 2rem;
  border-radius: 2rem;
  background-color: var(--color-grey);
}
.SplitPayment_crumbs__active__cB5tG {
  width: 5rem;
  background-color: var(--color-primary);
}

.SplitPayment_checks__h-1fI {
  display: flex;
  justify-content: space-between;
  margin-bottom: 2rem;
}
.SplitPayment_checks_group__pP2GQ {
  width: 38rem;
}

.SplitPayment_gp__BD3Qi {
  width: 40rem;
}
.SplitPayment_gp__vb__8ADng {
  position: relative;
  left: 20rem;
}
.SplitPayment_gp__vps__3\\+73\\+ {
  position: relative;
  left: 16.5rem;
}
.SplitPayment_gp__top__NfVq- {
  display: flex;
  justify-content: space-between;
  width: 44rem;
  margin-bottom: 3rem;
}
.SplitPayment_gp__BD3Qi table {
  width: 100%;
  max-width: 100%;
  border: none;
  border-collapse: collapse;
  box-sizing: border-box;
  text-align: left;
  font-size: var(--default-font-small);
}
.SplitPayment_gp__BD3Qi table tr {
  display: grid;
  grid-template-columns: 2.6fr repeat(2, 1.2fr);
  align-items: center;
  border-bottom: 1px solid var(--color-primary);
}
.SplitPayment_gp__BD3Qi table th {
  font-weight: 700;
  color: var(--color-primary);
}
.SplitPayment_gp__BD3Qi table td {
  cursor: pointer;
}
.SplitPayment_gp__BD3Qi table tbody > :first-child {
  margin-top: 1rem;
}
.SplitPayment_gp__BD3Qi table tbody > * {
  padding: 1rem 0;
}
.SplitPayment_gp__BD3Qi table tbody tr > :first-child {
  font-weight: 700;
}

.SplitPayment_ps__-IOlC {
  width: 40rem;
}
.SplitPayment_ps__breakdown__9mn-9 {
  width: 38rem;
}
.SplitPayment_ps__breakdown_sm__t8V90 {
  font-size: var(--default-font-small);
}
.SplitPayment_ps__breakdown_bdr__iUmt4 {
  border-bottom: 1px solid var(--color-primary);
}
.SplitPayment_ps__breakdown_total__WCHld {
  font-size: var(--default-font-small);
}
.SplitPayment_ps__breakdown__9mn-9 table {
  width: 100%;
  max-width: 100%;
  border: none;
  border-collapse: collapse;
  box-sizing: border-box;
  text-align: left;
  font-size: var(--default-font);
}
.SplitPayment_ps__breakdown__9mn-9 table thead tr,
.SplitPayment_ps__breakdown__9mn-9 table tbody tr {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  align-items: center;
}
.SplitPayment_ps__breakdown__9mn-9 table thead tr > :first-child,
.SplitPayment_ps__breakdown__9mn-9 table tbody tr > :first-child {
  justify-self: start;
  font-weight: 400;
}
.SplitPayment_ps__breakdown__9mn-9 table thead tr > :last-child,
.SplitPayment_ps__breakdown__9mn-9 table tbody tr > :last-child {
  justify-self: end;
  font-weight: 700;
}
.SplitPayment_ps__breakdown__9mn-9 table thead > *,
.SplitPayment_ps__breakdown__9mn-9 table tbody > * {
  padding: 1rem 0;
}
.SplitPayment_ps__breakdown__9mn-9 table th {
  color: var(--color-primary);
}

.SplitPayment_mp__U8iMg {
  width: 38rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.SplitPayment_success__lCsSv {
  height: 27rem;
  margin-bottom: 3rem;
}

.SplitPayment_simpleTable__3hmv\\+ {
  width: 100%;
  margin-top: 3rem;
  font-size: 1.2rem;
}
.SplitPayment_simpleTable__3hmv\\+ table {
  width: 100%;
  max-width: 100%;
  border: none;
  border-collapse: collapse;
  box-sizing: border-box;
  text-align: center;
  margin-top: 2rem;
}
.SplitPayment_simpleTable__3hmv\\+ table tr {
  padding: 0 1rem;
  align-items: center;
}
.SplitPayment_simpleTable__3hmv\\+ table th,
.SplitPayment_simpleTable__3hmv\\+ table td {
  padding: 1.2rem 2rem;
}
.SplitPayment_simpleTable__3hmv\\+ table th {
  font-weight: 700;
}
.SplitPayment_simpleTable__3hmv\\+ table thead {
  margin-bottom: 2rem;
}
.SplitPayment_simpleTable__3hmv\\+ table thead tr {
  background-color: var(--color-dark);
  border-radius: 1rem;
  color: var(--color-white);
}
.SplitPayment_simpleTable__3hmv\\+ table tbody tr {
  background-color: var(--color-white);
}
.SplitPayment_simpleTable__3hmv\\+ table tbody tr:nth-child(even) {
  background-color: var(--color-table-grey);
}
.SplitPayment_simpleTable__3hmv\\+ table .SplitPayment_pending__BMnfH {
  display: inline-flex;
  justify-content: center;
  line-height: 1;
  font-size: 1rem;
  border-radius: 1rem;
  background-color: var(--color-yellow);
  color: var(--color-dark);
  margin-top: 0.7rem;
  width: 100%;
}
.SplitPayment_simpleTable__3hmv\\+ table .SplitPayment_paid__yXALX {
  display: inline-flex;
  justify-content: center;
  line-height: 1;
  font-size: 1rem;
  border-radius: 1rem;
  background-color: var(--color-success);
  color: var(--color-white);
  margin-top: 0.7rem;
  width: 100%;
}
.SplitPayment_simpleTable__3hmv\\+ table .SplitPayment_low__s2a-G {
  display: inline-flex;
  justify-content: center;
  line-height: 1;
  font-size: 1rem;
  border-radius: 1rem;
  background-color: var(--color-error);
  color: var(--color-white);
  margin-top: 0.7rem;
  width: 60%;
}
.SplitPayment_simpleTable__3hmv\\+ table .SplitPayment_inStock__aStob {
  display: inline-flex;
  justify-content: center;
  line-height: 1;
  font-size: 1rem;
  border-radius: 1rem;
  background-color: var(--color-primary-8);
  color: var(--color-white);
  margin-top: 0.7rem;
  width: 60%;
}
.SplitPayment_simpleTable__3hmv\\+ table .SplitPayment_others__FIKVe {
  display: inline-flex;
  justify-content: center;
  line-height: 1;
  font-size: 1rem;
  border-radius: 1rem;
  background-color: var(--color-dark);
  color: var(--color-white);
  margin-top: 0.7rem;
  width: 100%;
}
.SplitPayment_simpleTable__3hmv\\+ table .SplitPayment_change__zmSbQ {
  display: inline-flex;
  justify-content: center;
  line-height: 1;
  font-size: 1rem;
  border-radius: 1rem;
  background-color: var(--color-primary);
  color: var(--color-white);
  margin-top: 0.7rem;
  width: 100%;
}
.SplitPayment_simpleTable__3hmv\\+ table .SplitPayment_action__text__BMegH {
  font-weight: 600;
  color: var(--color-primary);
  text-decoration: underline;
  cursor: pointer;
}

.SplitPayment_filter__1blDa {
  position: absolute;
  width: fit-content;
  right: 0;
  top: 75%;
  background-color: var(--color-white);
  padding: 1.5rem;
  border-radius: 1rem;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  z-index: 3;
}
@media only screen and (max-width: 31.25em) {
  .SplitPayment_filter__1blDa {
    top: 95%;
  }
}
.SplitPayment_filter_title__Wg-yX {
  width: 100%;
  font-size: var(--default-font-small);
  background-color: var(--color-light);
  padding: 1rem;
}
.SplitPayment_filter_title__Wg-yX > :not(:last-child) {
  margin-right: 1.5rem;
}
.SplitPayment_filter_group__kaX9k {
  display: flex;
  flex-wrap: wrap;
}
.SplitPayment_filter_group__kaX9k > :not(:last-child) {
  margin-right: 1rem;
}
.SplitPayment_filter_item__vuWDy {
  font-size: 1.2rem;
  padding: 0.5rem;
  border: 1px solid var(--color-dark);
  border-radius: 0.8rem;
  cursor: pointer;
  margin-bottom: 1rem;
}
.SplitPayment_filter_selectedItem__L7q1R {
  font-size: 1.2rem;
  padding: 0.5rem;
  border: 1px solid var(--color-dark);
  border-radius: 0.8rem;
  cursor: pointer;
  color: var(--color-white);
  font-weight: 700;
  background-color: var(--color-dark);
  margin-bottom: 1rem;
}

.SplitPayment_cpt__cI6xh {
  display: flex;
  font-size: var(--default-font-small);
  width: 38rem;
  overflow-x: scroll;
}
.SplitPayment_cpt__cI6xh::-webkit-scrollbar {
  width: 1rem;
  background-color: var(--color-white);
  border-radius: 0 1rem 1rem 0;
}
.SplitPayment_cpt__cI6xh::-webkit-scrollbar-thumb {
  background-color: var(--color-grey);
  border-radius: 1rem;
}
.SplitPayment_cpt_action__OaQ7e {
  font-weight: 700;
  color: var(--color-primary);
  cursor: pointer;
  text-decoration: underline;
}
.SplitPayment_cpt__cI6xh tr {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 2rem;
}
.SplitPayment_cpt__cI6xh thead {
  background-color: var(--color-grey-3);
  width: 19rem;
  position: fixed;
  z-index: 2;
}
.SplitPayment_cpt__cI6xh tbody {
  position: relative;
  left: 50%;
  display: flex;
}
.SplitPayment_cpt__cI6xh tbody tr {
  background-color: var(--color-light);
  width: 19rem;
}
.SplitPayment_cpt__cI6xh tbody tr:nth-child(even) {
  background-color: var(--color-white);
}

.SplitPayment_beneficiary__EEqyt {
  display: grid;
  grid-template-columns: 1fr 1fr;
  box-sizing: border-box;
  font-size: var(--default-font-small);
  width: 38rem;
  margin-bottom: 3rem;
  cursor: pointer;
}
.SplitPayment_beneficiary__EEqyt > * {
  padding: 1rem 0 1rem 0;
  text-align: center;
}
.SplitPayment_beneficiary__saved__bVbhp {
  background-color: var(--color-primary);
  color: var(--color-white);
  border-radius: 1rem 0 0 1rem;
  transition: all 0.4s;
}
.SplitPayment_beneficiary__saved_b__hrsvs {
  border: 1px solid var(--color-primary);
  border-radius: 1rem 0 0 1rem;
  transition: all 0.4s;
}
.SplitPayment_beneficiary__new__N\\+16E {
  border: 1px solid var(--color-primary);
  border-radius: 0 1rem 1rem 0;
  transition: all 0.4s;
}
.SplitPayment_beneficiary__new_b__M6Nuu {
  background-color: var(--color-primary);
  color: var(--color-white);
  border-radius: 0 1rem 1rem 0;
  transition: all 0.4s;
}

.SplitPayment_unit_group__KrtdG {
  width: 38rem;
  display: grid;
  grid-template-columns: repeat(2, 50%);
  gap: 2rem;
}
.SplitPayment_unit_card__FlVaU {
  background-color: var(--color-primary-3);
  padding: 2rem;
  box-sizing: border-box;
  border-radius: 2rem;
  font-size: 4rem;
  display: flex;
  align-items: center;
  flex-direction: column;
  color: var(--color-primary);
  cursor: pointer;
  transition: all 0.4s;
}
.SplitPayment_unit_card__FlVaU:hover {
  background-color: var(--color-primary-7);
}

.SplitPayment_searchbtnsection__O-1F5 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 0 2rem;
  margin-top: 2rem;
}
.SplitPayment_searchbtnsection__O-1F5 > :not(:last-child) {
  margin-right: 2rem;
}
@media only screen and (max-width: 43.75em) {
  .SplitPayment_searchbtnsection__O-1F5 > :not(:last-child) {
    margin-right: 0;
  }
}
@media only screen and (max-width: 43.75em) {
  .SplitPayment_searchbtnsection__O-1F5 {
    flex-direction: column;
    gap: 2rem;
  }
}

.SplitPayment_addProduct__beside__EFcWD {
  display: flex;
  justify-content: space-between;
  width: 38rem;
  margin-bottom: 3rem;
  margin-top: 3rem;
}
.SplitPayment_addProduct__note__dVfgs {
  width: 38rem;
}
.SplitPayment_addProduct__variation__f6Kni {
  display: flex;
  flex-wrap: wrap;
  gap: 20px 0;
  padding: 10px 20px;
  background-color: var(--color-primary-09);
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.08);
  border-radius: 10px;
}
.SplitPayment_addProduct__variation_info__so2Ok {
  flex: 0 0 50%;
}
.SplitPayment_addProduct__variation_info_price__vDGrc {
  display: flex;
  align-items: center;
}
.SplitPayment_addProduct__variation_info_price__vDGrc svg {
  margin-left: auto;
  color: var(--color-dark);
}

.SplitPayment_imageUpload__aIzRl {
  height: 10rem;
}

.SplitPayment_lengthColor__bYf5I {
  color: var(--color-error);
}

.SplitPayment_middleButtons__EcI4d {
  display: flex;
  justify-content: center;
  margin-top: 2rem;
}
.SplitPayment_middleButtons__EcI4d > :not(:last-child) {
  margin-right: 2rem;
}
@media only screen and (max-width: 31.25em) {
  .SplitPayment_middleButtons__EcI4d {
    flex-direction: column;
    align-items: center;
  }
  .SplitPayment_middleButtons__EcI4d > :not(:last-child) {
    margin-right: 0;
    margin-bottom: 2rem;
  }
}

.SplitPayment_selectCurrency__F3q-2 {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: var(--default-font-small);
  position: relative;
  margin-left: 2rem;
}
.SplitPayment_selectCurrency__text__9OkY5 {
  display: flex;
  margin-left: 1rem;
}
.SplitPayment_selectCurrency__icon__jUgjy {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 3rem;
  background-color: #f2f0f0;
  color: var(--color-primary);
  width: 5rem;
  height: 5rem;
  border-radius: 5rem;
  border: solid 1px var(--color-primary-4);
  cursor: pointer;
  transform: rotateZ(0);
  transition-duration: 500ms;
}
.SplitPayment_selectCurrency__icon__jUgjy:hover {
  box-shadow: 10px 10px 45px #bebebe, -15px -15px 30px #ffffff;
  background-color: var(--color-primary-3);
  transform: rotateZ(-180deg);
}
.SplitPayment_selectCurrency__icon_active__aww82 {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 3rem;
  background-color: #f2f0f0;
  color: var(--color-primary);
  width: 5rem;
  height: 5rem;
  border-radius: 5rem;
  border: solid 1px var(--color-primary-4);
  cursor: pointer;
  transition-duration: 500ms;
  box-shadow: 10px 10px 45px #bebebe, -15px -15px 30px #ffffff;
  background-color: var(--color-primary-3);
  transform: rotateZ(-180deg);
}
.SplitPayment_selectCurrency__list__DTcqk {
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  width: 5rem;
  background-color: #f2f0f0;
  color: var(--color-dark);
  border-radius: 1rem;
  box-shadow: 10px 10px 45px #bebebe, -15px -15px 30px #ffffff;
  position: absolute;
  top: 6rem;
  z-index: 30;
  border: solid 1px var(--color-primary-4);
}
.SplitPayment_selectCurrency__list_active__tOAf5 {
  background-color: var(--color-primary-7);
  color: var(--color-primary);
  font-weight: 700;
}
.SplitPayment_selectCurrency__list__DTcqk li {
  list-style: none;
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 1rem 0;
  box-sizing: border-box;
  border-radius: 1rem;
  cursor: pointer;
}
.SplitPayment_selectCurrency__list__DTcqk li:hover {
  background-color: var(--color-primary-7);
  color: var(--color-primary);
  font-weight: 700;
}

.SplitPayment_searchContainer__OPjra {
  display: flex;
  justify-self: center;
  max-width: fit-content;
}

.SplitPayment_searchAndFilter__Fldvw {
  display: flex;
  gap: 2rem;
  margin-top: 4rem;
}
@media only screen and (max-width: 50em) {
  .SplitPayment_searchAndFilter__Fldvw {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}

.SplitPayment_card__GeNLo {
  width: 38rem;
  background-color: var(--color-white);
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  padding: 2rem;
  margin-bottom: 2rem;
}
.SplitPayment_card_top__\\+Kvde {
  display: flex;
  justify-content: space-between;
}

.SplitPayment_type__D-Lk5 {
  margin-bottom: 2rem;
  margin-top: 2rem;
}
.SplitPayment_type_rcb__ksyyI {
  display: flex;
  gap: 1rem;
  align-items: center;
  width: 38rem;
  margin-top: 2rem;
}

.SplitPayment_filterClass__DK6Nk {
  display: flex;
  justify-content: space-between;
  margin-top: 8rem;
}
@media only screen and (max-width: 25em) {
  .SplitPayment_filterClass__DK6Nk {
    flex-direction: column;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/SplitPayment/SplitPayment.module.scss"],"names":[],"mappings":"AAGC;EACC,cAAA;EACA,mBAAA;AAFF;;AAOC;EACC,aAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EAEA,oCAAA;EACA,0CAAA;EACA,4BAAA;AALF;AAOE;EACC,kBAAA;AALH;AAQE;EACC,kBAAA;AANH;AASE;EACC,kBAAA;EACA,QAAA;EACA,QAAA;EACA,oCAAA;EACA,eAAA;EACA,mBAAA;EACA,4CAAA;EACA,UAAA;AAPH;AASG;EACC,mBAAA;AAPJ;AAWE;EACC,eAAA;EACA,eAAA;EACA,sBAAA;EACA,oCAAA;AATH;AAeG;EACC,eAAA;EACA,eAAA;EACA,sBAAA;EACA,oCAAA;EACA,gBAAA;EACA,2BAAA;EACA,6CAAA;AAbJ;AAgBG;EAIC,gBAAA;EACA,2BAAA;EACA,6CAAA;AAjBJ;AAsBC;EACC,WAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,qCAAA;EACA,SAAA;AApBF;AAsBE;EARD;IASE,qCAAA;EAnBD;AACF;AAqBE;EAZD;IAaE,qCAAA;EAlBD;AACF;AAqBE;EACC,sBAAA;EACA,aAAA;EACA,WAAA;EACA,oCAAA;EACA,mBAAA;AAnBH;AA2BE;EACC,wCAAA;AAzBH;AA4BE;EACC,qCAAA;AA1BH;AA6BE;EACC,wCAAA;AA3BH;AA8BE;EACC,oCAAA;EACA,yBAAA;AA5BH;AA+BE;EACC,sCAAA;EACA,yBAAA;AA7BH;AAgCE;EACC,qCAAA;AA9BH;AAmCC;EACC,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;AAjCF;AAmCE;EAND;IAOE,sBAAA;IACA,mBAAA;EAhCD;AACF;AAkCE;EACC,kBAAA;AAhCH;AAkCG;EAHD;IAIE,kBAAA;EA/BF;AACF;;AAoCA;EACC,aAAA;EACA,qCAAA;EACA,SAAA;AAjCD;AAmCC;EALD;IAME,qCAAA;EAhCA;AACF;;AAuCA;EACC,WAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,4CAAA;AApCD;;AAwCC;EACC,WAAA;EACA,gBAAA;EACA,oCAAA;AArCF;AAuCE;EACC,WAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;AArCH;AAuCG;EACC,aAAA;EACA,2DAAA;EACA,eAAA;EACA,mBAAA;AArCJ;AAuCI;EAND;IAOE,sCAAA;EApCH;AACF;AA2CG;;EAEC,oBAAA;AAzCJ;AA4CG;EACC,gBAAA;AA1CJ;AA6CG;EACC,eAAA;AA3CJ;AA+CI;EACC,qBAAA;AA7CL;AAgDI;EACC,wCAAA;EACA,qBAAA;AA9CL;AAgDK;EACC,wCAAA;EACA,qBAAA;AA9CN;;AAsDA;EACC,sBAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;AAnDD;AAqDC;EACC,4BAAA;AAnDF;AAsDC;EACC,yBAAA;AApDF;AAuDC;EACC,yBAAA;AArDF;;AA0DC;EACC,YAAA;EACA,gBAAA;AAvDF;AAyDE;EACC,gBAAA;EACA,eAAA;AAvDH;AAyDG;EACC,gBAAA;EACA,2BAAA;AAvDJ;AA2DE;EACC,0CAAA;EACA,cAAA;AAzDH;AA6DC;EACC,WAAA;AA3DF;AA6DE;EACC,YAAA;EACA,aAAA;EACA,mBAAA;EACA,sCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;AA3DH;AA+DC;EACC,YAAA;AA7DF;AAgEC;EACC,kBAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;AA9DF;AAgEE;EACC,kBAAA;AA9DH;AAkEC;EACC,aAAA;EACA,sBAAA;EACA,YAAA;AAhEF;AAkEE;EACC,mBAAA;AAhEH;AAoEC;EACC,WAAA;EACA,gBAAA;EACA,oCAAA;AAlEF;AAoEE;EACC,WAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;AAlEH;AAoEG;EACC,aAAA;EACA,4DAAA;EACA,eAAA;EACA,mBAAA;AAlEJ;AAoEI;EAND;IAOE,yCAAA;EAjEH;AACF;AAwEG;;EAEC,oBAAA;AAtEJ;AAyEG;EACC,gBAAA;AAvEJ;AA0EG;EACC,eAAA;AAxEJ;AA4EI;EACC,qBAAA;AA1EL;AA6EI;EACC,wCAAA;EACA,qBAAA;AA3EL;AA6EK;EACC,wCAAA;EACA,qBAAA;AA3EN;AA8EK;EACC,gBAAA;AA5EN;;AAoFA;EACC,aAAA;EACA,gBAAA;EACA,mBAAA;AAjFD;AAmFC;EACC,kBAAA;AAjFF;AAoFC;EACC,WAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,mCAAA;AAlFF;AAqFC;EACC,WAAA;EACA,sCAAA;AAnFF;;AAuFA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;AApFD;AAsFC;EACC,YAAA;AApFF;;AAwFA;EACC,YAAA;AArFD;AAuFC;EACC,kBAAA;EACA,WAAA;AArFF;AAwFC;EACC,kBAAA;EACA,aAAA;AAtFF;AAyFC;EACC,aAAA;EACA,8BAAA;EACA,YAAA;EACA,mBAAA;AAvFF;AA0FC;EACC,WAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;EACA,oCAAA;AAxFF;AA0FE;EACC,aAAA;EACA,6CAAA;EACA,mBAAA;EACA,6CAAA;AAxFH;AAmGE;EACC,gBAAA;EACA,2BAAA;AAjGH;AAoGE;EACC,eAAA;AAlGH;AAsGG;EACC,gBAAA;AApGJ;AAuGG;EACC,eAAA;AArGJ;AAyGI;EACC,gBAAA;AAvGL;;AA8GA;EACC,YAAA;AA3GD;AA6GC;EACC,YAAA;AA3GF;AA6GE;EACC,oCAAA;AA3GH;AA8GE;EACC,6CAAA;AA5GH;AA+GE;EACC,oCAAA;AA7GH;AAgHE;EACC,WAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;EACA,8BAAA;AA9GH;AAkHI;;EACC,aAAA;EACA,qCAAA;EACA,mBAAA;AA/GL;AAiHK;;EACC,mBAAA;EACA,gBAAA;AA9GN;AAiHK;;EACC,iBAAA;EACA,gBAAA;AA9GN;AAkHI;;EACC,eAAA;AA/GL;AAmHG;EACC,2BAAA;AAjHJ;;AAuHA;EACC,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AApHD;;AAuHA;EACC,aAAA;EACA,mBAAA;AApHD;;AAuHA;EACC,WAAA;EACA,gBAAA;EACA,iBAAA;AApHD;AAsHC;EACC,WAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;AApHF;AAsHE;EACC,eAAA;EACA,mBAAA;AApHH;AAuHE;;EAEC,oBAAA;AArHH;AAwHE;EACC,gBAAA;AAtHH;AAyHE;EACC,mBAAA;AAvHH;AAyHG;EACC,mCAAA;EACA,mBAAA;EACA,yBAAA;AAvHJ;AA4HG;EACC,oCAAA;AA1HJ;AA4HI;EACC,yCAAA;AA1HL;AA+HE;EACC,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,qCAAA;EACA,wBAAA;EACA,kBAAA;EACA,WAAA;AA7HH;AAgIE;EACC,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,sCAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;AA9HH;AAiIE;EACC,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,oCAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;AA/HH;AAkIE;EACC,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,wCAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;AAhIH;AAmIE;EACC,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,mCAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;AAjIH;AAoIE;EACC,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,sCAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;AAlIH;AAqIE;EACC,gBAAA;EACA,2BAAA;EACA,0BAAA;EACA,eAAA;AAnIH;;AAwIA;EACC,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,QAAA;EACA,oCAAA;EACA,eAAA;EACA,mBAAA;EACA,4CAAA;EACA,UAAA;AArID;AAuIC;EAXD;IAYE,QAAA;EApIA;AACF;AAgJC;EACC,WAAA;EACA,oCAAA;EACA,oCAAA;EACA,aAAA;AA9IF;AAgJE;EACC,oBAAA;AA9IH;AAkJC;EACC,aAAA;EACA,eAAA;AAhJF;AAmJE;EACC,kBAAA;AAjJH;AAqJC;EACC,iBAAA;EACA,eAAA;EACA,mCAAA;EACA,qBAAA;EACA,eAAA;EACA,mBAAA;AAnJF;AAsJC;EACC,iBAAA;EACA,eAAA;EACA,mCAAA;EACA,qBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,mCAAA;EACA,mBAAA;AApJF;;AAwJA;EACC,aAAA;EACA,oCAAA;EACA,YAAA;EACA,kBAAA;AArJD;AAuJC;EACC,WAAA;EACA,oCAAA;EACA,4BAAA;AArJF;AAwJC;EACC,mCAAA;EACA,mBAAA;AAtJF;AAyJC;EACC,gBAAA;EACA,2BAAA;EACA,eAAA;EACA,0BAAA;AAvJF;AA0JC;EACC,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,aAAA;AAxJF;AA2JC;EACC,qCAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;AAzJF;AA4JC;EACC,kBAAA;EACA,SAAA;EACA,aAAA;AA1JF;AA4JE;EACC,oCAAA;EACA,YAAA;AA1JH;AA4JG;EACC,oCAAA;AA1JJ;;AAgKA;EACC,aAAA;EACA,8BAAA;EACA,sBAAA;EACA,oCAAA;EACA,YAAA;EAEA,mBAAA;EACA,eAAA;AA9JD;AAgKC;EACC,sBAAA;EACA,kBAAA;AA9JF;AAiKC;EACC,sCAAA;EACA,yBAAA;EACA,4BAAA;EACA,oBAAA;AA/JF;AAiKE;EACC,sCAAA;EACA,4BAAA;EACA,oBAAA;AA/JH;AAmKC;EACC,sCAAA;EACA,4BAAA;EACA,oBAAA;AAjKF;AAmKE;EACC,sCAAA;EACA,yBAAA;EACA,4BAAA;EACA,oBAAA;AAjKH;;AAuKC;EACC,YAAA;EACA,aAAA;EACA,qCAAA;EACA,SAAA;AApKF;AAuKC;EACC,wCAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,2BAAA;EACA,eAAA;EACA,oBAAA;AArKF;AAuKE;EACC,wCAAA;AArKH;;AA0KA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AAvKD;AAyKC;EACC,kBAAA;AAvKF;AAyKE;EAHD;IAIE,eAAA;EAtKD;AACF;AAyKC;EAhBD;IAiBE,sBAAA;IACA,SAAA;EAtKA;AACF;;AA4KC;EACC,aAAA;EACA,8BAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;AAzKF;AA4KC;EACC,YAAA;AA1KF;AA6KC;EACC,aAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,yCAAA;EACA,uCAAA;EACA,mBAAA;AA3KF;AA6KE;EACC,aAAA;AA3KH;AA6KG;EACC,aAAA;EACA,mBAAA;AA3KJ;AA6KI;EACC,iBAAA;EACA,wBAAA;AA3KL;;AAkLA;EACC,aAAA;AA/KD;;AAkLA;EACC,yBAAA;AA/KD;;AAkLA;EACC,aAAA;EACA,uBAAA;EACA,gBAAA;AA/KD;AAiLC;EACC,kBAAA;AA/KF;AAkLC;EATD;IAUE,sBAAA;IACA,mBAAA;EA/KA;EAiLA;IACC,eAAA;IACA,mBAAA;EA/KD;AACF;;AAoLA;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,oCAAA;EACA,kBAAA;EACA,iBAAA;AAjLD;AAmLC;EACC,aAAA;EACA,iBAAA;AAjLF;AAoLC;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,wCAAA;EACA,eAAA;EACA,qBAAA;EACA,0BAAA;AAlLF;AAoLE;EACC,4DAAA;EAEA,wCAAA;EACA,2BAAA;AAnLH;AAsLE;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,wCAAA;EACA,eAAA;EACA,0BAAA;EACA,4DAAA;EAEA,wCAAA;EACA,2BAAA;AArLH;AA0LC;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,yBAAA;EACA,wBAAA;EACA,mBAAA;EACA,4DAAA;EAEA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,wCAAA;AAzLF;AA6LE;EACC,wCAAA;EACA,2BAAA;EACA,gBAAA;AA3LH;AA+LE;EACC,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;AA7LH;AA+LG;EACC,wCAAA;EACA,2BAAA;EACA,gBAAA;AA7LJ;;AAmMA;EACC,aAAA;EACA,oBAAA;EACA,sBAAA;AAhMD;;AAmMA;EACC,aAAA;EACA,SAAA;EACA,gBAAA;AAhMD;AAkMC;EALD;IAME,sBAAA;IACA,uBAAA;IACA,mBAAA;EA/LA;AACF;;AAkMA;EACC,YAAA;EACA,oCAAA;EACA,4CAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AA/LD;AAiMC;EACC,aAAA;EACA,8BAAA;AA/LF;;AAmMA;EACC,mBAAA;EACA,gBAAA;AAhMD;AAkMC;EACC,aAAA;EACA,SAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;AAhMF;;AAoMA;EACC,aAAA;EACA,8BAAA;EACA,gBAAA;AAjMD;AAmMC;EALD;IAMC,sBAAA;EAhMC;AACF","sourcesContent":["@import '../variables/breakpoints';\n\n.modal {\n\t&__img {\n\t\theight: 7.5rem;\n\t\tmargin-bottom: 3rem;\n\t}\n}\n\n.main {\n\t&_nav {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\tflex-wrap: wrap;\n\t\tmargin-top: 2rem;\n\t\tpadding: 0 2rem;\n\t\t// border-top: solid 1px var(--color-primary);\n\t\tbackground-color: var(--color-white);\n\t\tborder-bottom: solid 1px var(--color-dark);\n\t\tborder-radius: 1rem 1rem 0 0;\n\n\t\t&> :not(:last-child) {\n\t\t\tmargin-right: 3rem;\n\t\t}\n\n\t\t&_group {\n\t\t\tposition: relative;\n\t\t}\n\n\t\t&_more {\n\t\t\tposition: absolute;\n\t\t\tright: 0;\n\t\t\ttop: 75%;\n\t\t\tbackground-color: var(--color-white);\n\t\t\tpadding: 1.5rem;\n\t\t\tborder-radius: 1rem;\n\t\t\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\t\t\tz-index: 5;\n\n\t\t\t&> :not(last-child) {\n\t\t\t\tmargin-bottom: 1rem;\n\t\t\t}\n\t\t}\n\n\t\t&_item {\n\t\t\tcursor: pointer;\n\t\t\tpadding: 1rem 0;\n\t\t\tbox-sizing: border-box;\n\t\t\tfont-size: var(--default-font-small);\n\n\t\t\t// @media only screen and (max-width: $bp-600) {\n\t\t\t// \twidth: 47%;\n\t\t\t// }\n\n\t\t\t&_active {\n\t\t\t\tcursor: pointer;\n\t\t\t\tpadding: 1rem 0;\n\t\t\t\tbox-sizing: border-box;\n\t\t\t\tfont-size: var(--default-font-small);\n\t\t\t\tfont-weight: 700;\n\t\t\t\tcolor: var(--color-primary);\n\t\t\t\tborder-bottom: solid 2px var(--color-primary);\n\t\t\t}\n\n\t\t\t&:hover,\n\t\t\t&:focus,\n\t\t\t&:focus-visible,\n\t\t\t&:focus-within {\n\t\t\t\tfont-weight: 700;\n\t\t\t\tcolor: var(--color-primary);\n\t\t\t\tborder-bottom: solid 2px var(--color-primary);\n\t\t\t}\n\t\t}\n\t}\n\n\t&__metrics {\n\t\twidth: 100%;\n\t\tdisplay: grid;\n\t\ttext-align: center;\n\t\tbox-sizing: border-box;\n\t\tgrid-template-columns: repeat(4, 1fr);\n\t\tgap: 2rem;\n\n\t\t@media only screen and (max-width: $bp-800) {\n\t\t\tgrid-template-columns: repeat(3, 1fr);\n\t\t}\n\n\t\t@media only screen and (max-width: $bp-600) {\n\t\t\tgrid-template-columns: repeat(2, 1fr);\n\t\t\t;\n\t\t}\n\n\t\t&_container {\n\t\t\tbox-sizing: border-box;\n\t\t\tpadding: 2rem;\n\t\t\twidth: 100%;\n\t\t\tbackground-color: var(--color-white);\n\t\t\tborder-radius: 2rem;\n\t\t}\n\n\n\t\t// @media only screen and (max-width: $bp-500) {\n\t\t// \tgrid-template-columns: 100%;\n\t\t// }\n\n\t\t&_lightBlue {\n\t\t\tbackground-color: var(--color-primary-3);\n\t\t}\n\n\t\t&_grey {\n\t\t\tbackground-color: var(--color-grey-2);\n\t\t}\n\n\t\t&_lightBlue2 {\n\t\t\tbackground-color: var(--color-primary-7);\n\t\t}\n\n\t\t&_red {\n\t\t\tbackground-color: var(--color-error);\n\t\t\tcolor: var(--color-white);\n\t\t}\n\n\t\t&_green {\n\t\t\tbackground-color: var(--color-success);\n\t\t\tcolor: var(--color-white);\n\t\t}\n\n\t\t&_yellow {\n\t\t\tbackground-color: var(--color-yellow);\n\t\t}\n\t}\n\n\n\t&__dropdowns {\n\t\tmargin-top: 2rem;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\twidth: 100%;\n\n\t\t@media only screen and (max-width: $bp-700) {\n\t\t\tflex-direction: column;\n\t\t\talign-items: center;\n\t\t}\n\n\t\t&> :not(last-child) {\n\t\t\tmargin-right: 2rem;\n\n\t\t\t@media only screen and (max-width: $bp-700) {\n\t\t\t\tmargin-right: none;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.threeCards {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(3, 1fr);\n\tgap: 2rem;\n\n\t@media only screen and (max-width: $bp-600) {\n\t\tgrid-template-columns: repeat(2, 1fr);\n\t}\n\n\t// @media only screen and (max-width: $bp-500) {\n\t// \tgrid-template-columns: 100%;\n\t// }\n}\n\n.singleCard {\n\twidth: 100%;\n\tbackground-color: var(--color-white);\n\tpadding: 2rem;\n\tborder-radius: 2rem;\n\tdisplay: flex;\n\tflex-direction: column;\n\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n}\n\n.payroll {\n\t&_table {\n\t\twidth: 100%;\n\t\tmargin-top: 3rem;\n\t\tfont-size: var(--default-font-small);\n\n\t\ttable {\n\t\t\twidth: 100%;\n\t\t\tmax-width: 100%;\n\t\t\tborder: none;\n\t\t\tborder-collapse: collapse;\n\t\t\tbox-sizing: border-box;\n\t\t\ttext-align: left;\n\n\t\t\ttr {\n\t\t\t\tdisplay: grid;\n\t\t\t\tgrid-template-columns: 5% 18% 15% repeat(2, 12%) 9% 20% 10%;\n\t\t\t\tpadding: 0 1rem;\n\t\t\t\talign-items: center;\n\n\t\t\t\t@media only screen and (max-width: $bp-800) {\n\t\t\t\t\tgrid-template-columns: 15% 40% 30% 15%;\n\t\t\t\t}\n\n\t\t\t\t// @media only screen and (max-width: $bp-600) {\n\t\t\t\t// \tgrid-template-columns: 1fr;\n\t\t\t\t// }\n\t\t\t}\n\n\t\t\tth,\n\t\t\ttd {\n\t\t\t\tpadding: 2.2rem 2rem;\n\t\t\t}\n\n\t\t\tth {\n\t\t\t\tfont-weight: 700;\n\t\t\t}\n\n\t\t\ttd {\n\t\t\t\tcursor: pointer;\n\t\t\t}\n\n\t\t\ttbody {\n\t\t\t\t&> :not(:last-child) {\n\t\t\t\t\tmargin-bottom: 1.5rem;\n\t\t\t\t}\n\n\t\t\t\ttr {\n\t\t\t\t\tbackground-color: var(--color-primary-3);\n\t\t\t\t\tborder-radius: 1.3rem;\n\n\t\t\t\t\t&:nth-child(even) {\n\t\t\t\t\t\tbackground-color: var(--color-primary-7);\n\t\t\t\t\t\tborder-radius: 1.3rem;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.status {\n\tbox-sizing: border-box;\n\twidth: 5vw;\n\theight: 2vw;\n\tcolor: var(--color-error);\n\n\t&__pending {\n\t\tcolor: var(--color-yellow-3);\n\t}\n\n\t&__paid {\n\t\tcolor: var(--color-green);\n\t}\n\n\t&__failed {\n\t\tcolor: var(--color-error);\n\t}\n}\n\n.employee {\n\t&__list {\n\t\twidth: 38rem;\n\t\tmargin-top: 5rem;\n\n\t\tli {\n\t\t\tlist-style: none;\n\t\t\tcursor: pointer;\n\n\t\t\t&:hover {\n\t\t\t\tfont-weight: 700;\n\t\t\t\tcolor: var(--color-primary);\n\t\t\t}\n\t\t}\n\n\t\t&_line {\n\t\t\tborder-top: 1px solid var(--color-primary);\n\t\t\tmargin: 2rem 0;\n\t\t}\n\t}\n\n\t&__avatar {\n\t\twidth: 9rem;\n\n\t\t&_container {\n\t\t\twidth: 10rem;\n\t\t\theight: 10rem;\n\t\t\tborder-radius: 7rem;\n\t\t\tborder: 1px solid var(--color-primary);\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t\tmargin: 3rem 0;\n\t\t}\n\t}\n\n\t&__details {\n\t\twidth: 38rem;\n\t}\n\n\t&__editButton {\n\t\tposition: relative;\n\t\tright: 17rem;\n\t\tdisplay: flex;\n\t\tfont-size: 2.5rem;\n\t\talign-items: center;\n\t\tcursor: pointer;\n\n\t\t&> :not(:last-child) {\n\t\t\tmargin-right: 1rem;\n\t\t}\n\t}\n\n\t&__terminate {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\twidth: 38rem;\n\n\t\t&> :not(:last-child) {\n\t\t\tmargin-bottom: 1rem;\n\t\t}\n\t}\n\n\t&_table {\n\t\twidth: 100%;\n\t\tmargin-top: 3rem;\n\t\tfont-size: var(--default-font-small);\n\n\t\ttable {\n\t\t\twidth: 100%;\n\t\t\tmax-width: 100%;\n\t\t\tborder: none;\n\t\t\tborder-collapse: collapse;\n\t\t\tbox-sizing: border-box;\n\t\t\ttext-align: left;\n\n\t\t\ttr {\n\t\t\t\tdisplay: grid;\n\t\t\t\tgrid-template-columns: 16% repeat(3, 15%) 15% 10% 10% 5% 15%;\n\t\t\t\tpadding: 0 1rem;\n\t\t\t\talign-items: center;\n\n\t\t\t\t@media only screen and (max-width: $bp-800) {\n\t\t\t\t\tgrid-template-columns: repeat(2, 40%) 20%;\n\t\t\t\t}\n\n\t\t\t\t// @media only screen and (max-width: $bp-600) {\n\t\t\t\t// \tgrid-template-columns: 1fr;\n\t\t\t\t// }\n\t\t\t}\n\n\t\t\tth,\n\t\t\ttd {\n\t\t\t\tpadding: 2.2rem 1rem;\n\t\t\t}\n\n\t\t\tth {\n\t\t\t\tfont-weight: 700;\n\t\t\t}\n\n\t\t\ttd {\n\t\t\t\tcursor: pointer;\n\t\t\t}\n\n\t\t\ttbody {\n\t\t\t\t&> :not(:last-child) {\n\t\t\t\t\tmargin-bottom: 1.5rem;\n\t\t\t\t}\n\n\t\t\t\ttr {\n\t\t\t\t\tbackground-color: var(--color-primary-3);\n\t\t\t\t\tborder-radius: 1.3rem;\n\n\t\t\t\t\t&:nth-child(even) {\n\t\t\t\t\t\tbackground-color: var(--color-primary-7);\n\t\t\t\t\t\tborder-radius: 1.3rem;\n\t\t\t\t\t}\n\n\t\t\t\t\t&> :last-child {\n\t\t\t\t\t\tfont-weight: 700;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.crumbs {\n\tdisplay: flex;\n\tmargin-top: 2rem;\n\tmargin-bottom: 1rem;\n\n\t&> :not(:last-child) {\n\t\tmargin-right: 2rem;\n\t}\n\n\t&__main {\n\t\tcontent: '';\n\t\theight: 2rem;\n\t\twidth: 2rem;\n\t\tborder-radius: 2rem;\n\t\tbackground-color: var(--color-grey);\n\t}\n\n\t&__active {\n\t\twidth: 5rem;\n\t\tbackground-color: var(--color-primary);\n\t}\n}\n\n.checks {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tmargin-bottom: 2rem;\n\n\t&_group {\n\t\twidth: 38rem;\n\t}\n}\n\n.gp {\n\twidth: 40rem;\n\n\t&__vb {\n\t\tposition: relative;\n\t\tleft: 20rem;\n\t}\n\n\t&__vps {\n\t\tposition: relative;\n\t\tleft: 16.5rem;\n\t}\n\n\t&__top {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\twidth: 44rem;\n\t\tmargin-bottom: 3rem;\n\t}\n\n\ttable {\n\t\twidth: 100%;\n\t\tmax-width: 100%;\n\t\tborder: none;\n\t\tborder-collapse: collapse;\n\t\tbox-sizing: border-box;\n\t\ttext-align: left;\n\t\tfont-size: var(--default-font-small);\n\n\t\ttr {\n\t\t\tdisplay: grid;\n\t\t\tgrid-template-columns: 2.6fr repeat(2, 1.2fr);\n\t\t\talign-items: center;\n\t\t\tborder-bottom: 1px solid var(--color-primary);\n\n\t\t\t// @media only screen and (max-width: $bp-900) {\n\t\t\t// \tgrid-template-columns: 2.3fr 1.6fr 2fr 0.9fr 0.2fr;\n\t\t\t// }\n\n\t\t\t// @media only screen and (max-width: $bp-600) {\n\t\t\t// \tgrid-template-columns: 1fr;\n\t\t\t// }\n\t\t}\n\n\t\tth {\n\t\t\tfont-weight: 700;\n\t\t\tcolor: var(--color-primary);\n\t\t}\n\n\t\ttd {\n\t\t\tcursor: pointer;\n\t\t}\n\n\t\ttbody {\n\t\t\t&> :first-child {\n\t\t\t\tmargin-top: 1rem;\n\t\t\t}\n\n\t\t\t&>* {\n\t\t\t\tpadding: 1rem 0;\n\t\t\t}\n\n\t\t\ttr {\n\t\t\t\t&> :first-child {\n\t\t\t\t\tfont-weight: 700;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.ps {\n\twidth: 40rem;\n\n\t&__breakdown {\n\t\twidth: 38rem;\n\n\t\t&_sm {\n\t\t\tfont-size: var(--default-font-small);\n\t\t}\n\n\t\t&_bdr {\n\t\t\tborder-bottom: 1px solid var(--color-primary);\n\t\t}\n\n\t\t&_total {\n\t\t\tfont-size: var(--default-font-small);\n\t\t}\n\n\t\ttable {\n\t\t\twidth: 100%;\n\t\t\tmax-width: 100%;\n\t\t\tborder: none;\n\t\t\tborder-collapse: collapse;\n\t\t\tbox-sizing: border-box;\n\t\t\ttext-align: left;\n\t\t\tfont-size: var(--default-font);\n\n\t\t\tthead,\n\t\t\ttbody {\n\t\t\t\ttr {\n\t\t\t\t\tdisplay: grid;\n\t\t\t\t\tgrid-template-columns: repeat(2, 1fr);\n\t\t\t\t\talign-items: center;\n\n\t\t\t\t\t&> :first-child {\n\t\t\t\t\t\tjustify-self: start;\n\t\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\t}\n\n\t\t\t\t\t&> :last-child {\n\t\t\t\t\t\tjustify-self: end;\n\t\t\t\t\t\tfont-weight: 700;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t&>* {\n\t\t\t\t\tpadding: 1rem 0;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\tth {\n\t\t\t\tcolor: var(--color-primary);\n\t\t\t}\n\t\t}\n\t}\n}\n\n.mp {\n\twidth: 38rem;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n}\n\n.success {\n\theight: 27rem;\n\tmargin-bottom: 3rem;\n}\n\n.simpleTable {\n\twidth: 100%;\n\tmargin-top: 3rem;\n\tfont-size: 1.2rem;\n\n\ttable {\n\t\twidth: 100%;\n\t\tmax-width: 100%;\n\t\tborder: none;\n\t\tborder-collapse: collapse;\n\t\tbox-sizing: border-box;\n\t\ttext-align: center;\n\t\tmargin-top: 2rem;\n\n\t\ttr {\n\t\t\tpadding: 0 1rem;\n\t\t\talign-items: center;\n\t\t}\n\n\t\tth,\n\t\ttd {\n\t\t\tpadding: 1.2rem 2rem;\n\t\t}\n\n\t\tth {\n\t\t\tfont-weight: 700;\n\t\t}\n\n\t\tthead {\n\t\t\tmargin-bottom: 2rem;\n\n\t\t\ttr {\n\t\t\t\tbackground-color: var(--color-dark);\n\t\t\t\tborder-radius: 1rem;\n\t\t\t\tcolor: var(--color-white);\n\t\t\t}\n\t\t}\n\n\t\ttbody {\n\t\t\ttr {\n\t\t\t\tbackground-color: var(--color-white);\n\n\t\t\t\t&:nth-child(even) {\n\t\t\t\t\tbackground-color: var(--color-table-grey);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.pending {\n\t\t\tdisplay: inline-flex;\n\t\t\tjustify-content: center;\n\t\t\tline-height: 1;\n\t\t\tfont-size: 1rem;\n\t\t\tborder-radius: 1rem;\n\t\t\tbackground-color: var(--color-yellow);\n\t\t\tcolor: var(--color-dark);\n\t\t\tmargin-top: 0.7rem;\n\t\t\twidth: 100%;\n\t\t}\n\n\t\t.paid {\n\t\t\tdisplay: inline-flex;\n\t\t\tjustify-content: center;\n\t\t\tline-height: 1;\n\t\t\tfont-size: 1rem;\n\t\t\tborder-radius: 1rem;\n\t\t\tbackground-color: var(--color-success);\n\t\t\tcolor: var(--color-white);\n\t\t\tmargin-top: 0.7rem;\n\t\t\twidth: 100%;\n\t\t}\n\n\t\t.low {\n\t\t\tdisplay: inline-flex;\n\t\t\tjustify-content: center;\n\t\t\tline-height: 1;\n\t\t\tfont-size: 1rem;\n\t\t\tborder-radius: 1rem;\n\t\t\tbackground-color: var(--color-error);\n\t\t\tcolor: var(--color-white);\n\t\t\tmargin-top: 0.7rem;\n\t\t\twidth: 60%;\n\t\t}\n\n\t\t.inStock {\n\t\t\tdisplay: inline-flex;\n\t\t\tjustify-content: center;\n\t\t\tline-height: 1;\n\t\t\tfont-size: 1rem;\n\t\t\tborder-radius: 1rem;\n\t\t\tbackground-color: var(--color-primary-8);\n\t\t\tcolor: var(--color-white);\n\t\t\tmargin-top: 0.7rem;\n\t\t\twidth: 60%;\n\t\t}\n\n\t\t.others {\n\t\t\tdisplay: inline-flex;\n\t\t\tjustify-content: center;\n\t\t\tline-height: 1;\n\t\t\tfont-size: 1rem;\n\t\t\tborder-radius: 1rem;\n\t\t\tbackground-color: var(--color-dark);\n\t\t\tcolor: var(--color-white);\n\t\t\tmargin-top: 0.7rem;\n\t\t\twidth: 100%;\n\t\t}\n\n\t\t.change {\n\t\t\tdisplay: inline-flex;\n\t\t\tjustify-content: center;\n\t\t\tline-height: 1;\n\t\t\tfont-size: 1rem;\n\t\t\tborder-radius: 1rem;\n\t\t\tbackground-color: var(--color-primary);\n\t\t\tcolor: var(--color-white);\n\t\t\tmargin-top: 0.7rem;\n\t\t\twidth: 100%;\n\t\t}\n\n\t\t.action__text {\n\t\t\tfont-weight: 600;\n\t\t\tcolor: var(--color-primary);\n\t\t\ttext-decoration: underline;\n\t\t\tcursor: pointer;\n\t\t}\n\t}\n}\n\n.filter {\n\tposition: absolute;\n\twidth: fit-content;\n\tright: 0;\n\ttop: 75%;\n\tbackground-color: var(--color-white);\n\tpadding: 1.5rem;\n\tborder-radius: 1rem;\n\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\tz-index: 3;\n\n\t@media only screen and (max-width: $bp-500) {\n\t\ttop: 95%;\n\t}\n\n\t// clip-path: polygon(\n\t// \t48% 10%,\n\t// \t50% 0,\n\t// \t52% 10%,\n\t// \t100% 10%,\n\t// \t100% 100%,\n\t// \t0 100%,\n\t// \t0 10%\n\t// );\n\n\t&_title {\n\t\twidth: 100%;\n\t\tfont-size: var(--default-font-small);\n\t\tbackground-color: var(--color-light);\n\t\tpadding: 1rem;\n\n\t\t&> :not(:last-child) {\n\t\t\tmargin-right: 1.5rem;\n\t\t}\n\t}\n\n\t&_group {\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\n\t\t// margin: 2rem 0;\n\t\t&> :not(:last-child) {\n\t\t\tmargin-right: 1rem;\n\t\t}\n\t}\n\n\t&_item {\n\t\tfont-size: 1.2rem;\n\t\tpadding: 0.5rem;\n\t\tborder: 1px solid var(--color-dark);\n\t\tborder-radius: 0.8rem;\n\t\tcursor: pointer;\n\t\tmargin-bottom: 1rem;\n\t}\n\n\t&_selectedItem {\n\t\tfont-size: 1.2rem;\n\t\tpadding: 0.5rem;\n\t\tborder: 1px solid var(--color-dark);\n\t\tborder-radius: 0.8rem;\n\t\tcursor: pointer;\n\t\tcolor: var(--color-white);\n\t\tfont-weight: 700;\n\t\tbackground-color: var(--color-dark);\n\t\tmargin-bottom: 1rem;\n\t}\n}\n\n.cpt {\n\tdisplay: flex;\n\tfont-size: var(--default-font-small);\n\twidth: 38rem;\n\toverflow-x: scroll;\n\n\t&::-webkit-scrollbar {\n\t\twidth: 1rem;\n\t\tbackground-color: var(--color-white);\n\t\tborder-radius: 0 1rem 1rem 0;\n\t}\n\n\t&::-webkit-scrollbar-thumb {\n\t\tbackground-color: var(--color-grey);\n\t\tborder-radius: 1rem;\n\t}\n\n\t&_action {\n\t\tfont-weight: 700;\n\t\tcolor: var(--color-primary);\n\t\tcursor: pointer;\n\t\ttext-decoration: underline;\n\t}\n\n\ttr {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: flex-start;\n\t\tpadding: 2rem;\n\t}\n\n\tthead {\n\t\tbackground-color: var(--color-grey-3);\n\t\twidth: 19rem;\n\t\tposition: fixed;\n\t\tz-index: 2;\n\t}\n\n\ttbody {\n\t\tposition: relative;\n\t\tleft: 50%;\n\t\tdisplay: flex;\n\n\t\ttr {\n\t\t\tbackground-color: var(--color-light);\n\t\t\twidth: 19rem;\n\n\t\t\t&:nth-child(even) {\n\t\t\t\tbackground-color: var(--color-white);\n\t\t\t}\n\t\t}\n\t}\n}\n\n.beneficiary {\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 1fr;\n\tbox-sizing: border-box;\n\tfont-size: var(--default-font-small);\n\twidth: 38rem;\n\n\tmargin-bottom: 3rem;\n\tcursor: pointer;\n\n\t&>* {\n\t\tpadding: 1rem 0 1rem 0;\n\t\ttext-align: center;\n\t}\n\n\t&__saved {\n\t\tbackground-color: var(--color-primary);\n\t\tcolor: var(--color-white);\n\t\tborder-radius: 1rem 0 0 1rem;\n\t\ttransition: all 0.4s;\n\n\t\t&_b {\n\t\t\tborder: 1px solid var(--color-primary);\n\t\t\tborder-radius: 1rem 0 0 1rem;\n\t\t\ttransition: all 0.4s;\n\t\t}\n\t}\n\n\t&__new {\n\t\tborder: 1px solid var(--color-primary);\n\t\tborder-radius: 0 1rem 1rem 0;\n\t\ttransition: all 0.4s;\n\n\t\t&_b {\n\t\t\tbackground-color: var(--color-primary);\n\t\t\tcolor: var(--color-white);\n\t\t\tborder-radius: 0 1rem 1rem 0;\n\t\t\ttransition: all 0.4s;\n\t\t}\n\t}\n}\n\n.unit {\n\t&_group {\n\t\twidth: 38rem;\n\t\tdisplay: grid;\n\t\tgrid-template-columns: repeat(2, 50%);\n\t\tgap: 2rem;\n\t}\n\n\t&_card {\n\t\tbackground-color: var(--color-primary-3);\n\t\tpadding: 2rem;\n\t\tbox-sizing: border-box;\n\t\tborder-radius: 2rem;\n\t\tfont-size: 4rem;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tflex-direction: column;\n\t\tcolor: var(--color-primary);\n\t\tcursor: pointer;\n\t\ttransition: all 0.4s;\n\n\t\t&:hover {\n\t\t\tbackground-color: var(--color-primary-7);\n\t\t}\n\t}\n}\n\n.searchbtnsection {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\twidth: 100%;\n\tpadding: 0 2rem;\n\tmargin-top: 2rem;\n\n\t&> :not(:last-child) {\n\t\tmargin-right: 2rem;\n\n\t\t@media only screen and (max-width: $bp-700) {\n\t\t\tmargin-right: 0;\n\t\t}\n\t}\n\n\t@media only screen and (max-width: $bp-700) {\n\t\tflex-direction: column;\n\t\tgap: 2rem;\n\t}\n\n}\n\n.addProduct {\n\n\t&__beside {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\twidth: 38rem;\n\t\tmargin-bottom: 3rem;\n\t\tmargin-top: 3rem;\n\t}\n\n\t&__note {\n\t\twidth: 38rem;\n\t}\n\n\t&__variation {\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t\tgap: 20px 0;\n\t\tpadding: 10px 20px;\n\t\tbackground-color: var(--color-primary-09);\n\t\tbox-shadow: 0 0 5px rgba(0, 0, 0, 0.08);\n\t\tborder-radius: 10px;\n\n\t\t&_info {\n\t\t\tflex: 0 0 50%;\n\n\t\t\t&_price {\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\n\t\t\t\tsvg {\n\t\t\t\t\tmargin-left: auto;\n\t\t\t\t\tcolor: var(--color-dark);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.imageUpload {\n\theight: 10rem;\n}\n\n.lengthColor {\n\tcolor: var(--color-error);\n}\n\n.middleButtons {\n\tdisplay: flex;\n\tjustify-content: center;\n\tmargin-top: 2rem;\n\n\t&>:not(:last-child) {\n\t\tmargin-right: 2rem;\n\t}\n\n\t@media only screen and (max-width: $bp-500) {\n\t\tflex-direction: column;\n\t\talign-items: center;\n\n\t\t&>:not(:last-child) {\n\t\t\tmargin-right: 0;\n\t\t\tmargin-bottom: 2rem;\n\t\t}\n\t}\n\n}\n\n.selectCurrency {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tfont-size: var(--default-font-small);\n\tposition: relative;\n\tmargin-left: 2rem;\n\n\t&__text {\n\t\tdisplay: flex;\n\t\tmargin-left: 1rem;\n\t}\n\n\t&__icon {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tfont-size: 3rem;\n\t\tbackground-color: #f2f0f0;\n\t\tcolor: var(--color-primary);\n\t\twidth: 5rem;\n\t\theight: 5rem;\n\t\tborder-radius: 5rem;\n\t\tborder: solid 1px var(--color-primary-4);\n\t\tcursor: pointer;\n\t\ttransform: rotateZ(0);\n\t\ttransition-duration: 500ms;\n\n\t\t&:hover {\n\t\t\tbox-shadow: 10px 10px 45px #bebebe,\n\t\t\t\t-15px -15px 30px #ffffff;\n\t\t\tbackground-color: var(--color-primary-3);\n\t\t\ttransform: rotateZ(-180deg);\n\t\t}\n\n\t\t&_active {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t\tfont-size: 3rem;\n\t\t\tbackground-color: #f2f0f0;\n\t\t\tcolor: var(--color-primary);\n\t\t\twidth: 5rem;\n\t\t\theight: 5rem;\n\t\t\tborder-radius: 5rem;\n\t\t\tborder: solid 1px var(--color-primary-4);\n\t\t\tcursor: pointer;\n\t\t\ttransition-duration: 500ms;\n\t\t\tbox-shadow: 10px 10px 45px #bebebe,\n\t\t\t\t-15px -15px 30px #ffffff;\n\t\t\tbackground-color: var(--color-primary-3);\n\t\t\ttransform: rotateZ(-180deg)\n\t\t}\n\n\t}\n\n\t&__list {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tbox-sizing: border-box;\n\t\twidth: 5rem;\n\t\tbackground-color: #f2f0f0;\n\t\tcolor: var(--color-dark);\n\t\tborder-radius: 1rem;\n\t\tbox-shadow: 10px 10px 45px #bebebe,\n\t\t\t-15px -15px 30px #ffffff;\n\t\tposition: absolute;\n\t\ttop: 6rem;\n\t\tz-index: 30;\n\t\tborder: solid 1px var(--color-primary-4);\n\n\n\n\t\t&_active {\n\t\t\tbackground-color: var(--color-primary-7);\n\t\t\tcolor: var(--color-primary);\n\t\t\tfont-weight: 700;\n\t\t}\n\n\n\t\tli {\n\t\t\tlist-style: none;\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\twidth: 100%;\n\t\t\tpadding: 1rem 0;\n\t\t\tbox-sizing: border-box;\n\t\t\tborder-radius: 1rem;\n\t\t\tcursor: pointer;\n\n\t\t\t&:hover {\n\t\t\t\tbackground-color: var(--color-primary-7);\n\t\t\t\tcolor: var(--color-primary);\n\t\t\t\tfont-weight: 700;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.searchContainer {\n\tdisplay: flex;\n\tjustify-self: center;\n\tmax-width: fit-content;\n}\n\n.searchAndFilter {\n\tdisplay: flex;\n\tgap: 2rem;\n\tmargin-top: 4rem;\n\n\t@media only screen and (max-width: $bp-800) {\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t}\n}\n\n.card {\n\twidth: 38rem;\n\tbackground-color: var(--color-white);\n\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\tborder-radius: 8px;\n\tpadding: 2rem;\n\tmargin-bottom: 2rem;\n\n\t&_top {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t}\n}\n\n.type {\n\tmargin-bottom: 2rem;\n\tmargin-top: 2rem;\n\n\t&_rcb {\n\t\tdisplay: flex;\n\t\tgap: 1rem;\n\t\talign-items: center;\n\t\twidth: 38rem;\n\t\tmargin-top: 2rem;\n\t}\n}\n\n.filterClass {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tmargin-top: 8rem;\n\n\t@media only screen and (max-width: $bp-400) {\n\tflex-direction: column;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal__img": `SplitPayment_modal__img__sRT9L`,
	"main_nav": `SplitPayment_main_nav__QkwDp`,
	"main_nav_group": `SplitPayment_main_nav_group__W0zgQ`,
	"main_nav_more": `SplitPayment_main_nav_more__Db6Z6`,
	"main_nav_item": `SplitPayment_main_nav_item__sh+Ft`,
	"main_nav_item_active": `SplitPayment_main_nav_item_active__J2674`,
	"main__metrics": `SplitPayment_main__metrics__SvcIB`,
	"main__metrics_container": `SplitPayment_main__metrics_container__hb26z`,
	"main__metrics_lightBlue": `SplitPayment_main__metrics_lightBlue__bhqFF`,
	"main__metrics_grey": `SplitPayment_main__metrics_grey__+FPMD`,
	"main__metrics_lightBlue2": `SplitPayment_main__metrics_lightBlue2__o32lk`,
	"main__metrics_red": `SplitPayment_main__metrics_red__wD9K0`,
	"main__metrics_green": `SplitPayment_main__metrics_green__Nb3gy`,
	"main__metrics_yellow": `SplitPayment_main__metrics_yellow__hbDH2`,
	"main__dropdowns": `SplitPayment_main__dropdowns__CLgEN`,
	"threeCards": `SplitPayment_threeCards__y1Xqo`,
	"singleCard": `SplitPayment_singleCard__Z0MDb`,
	"payroll_table": `SplitPayment_payroll_table__uRv+r`,
	"status": `SplitPayment_status__W0HLs`,
	"status__pending": `SplitPayment_status__pending__VZA8D`,
	"status__paid": `SplitPayment_status__paid__wJtfk`,
	"status__failed": `SplitPayment_status__failed__W2KUL`,
	"employee__list": `SplitPayment_employee__list__oInCO`,
	"employee__list_line": `SplitPayment_employee__list_line__yLlCl`,
	"employee__avatar": `SplitPayment_employee__avatar__UOfpg`,
	"employee__avatar_container": `SplitPayment_employee__avatar_container__MFd72`,
	"employee__details": `SplitPayment_employee__details__hmbvB`,
	"employee__editButton": `SplitPayment_employee__editButton__T6jI4`,
	"employee__terminate": `SplitPayment_employee__terminate__26-y1`,
	"employee_table": `SplitPayment_employee_table__0hPLy`,
	"crumbs": `SplitPayment_crumbs__5XKYy`,
	"crumbs__main": `SplitPayment_crumbs__main__6XoJH`,
	"crumbs__active": `SplitPayment_crumbs__active__cB5tG`,
	"checks": `SplitPayment_checks__h-1fI`,
	"checks_group": `SplitPayment_checks_group__pP2GQ`,
	"gp": `SplitPayment_gp__BD3Qi`,
	"gp__vb": `SplitPayment_gp__vb__8ADng`,
	"gp__vps": `SplitPayment_gp__vps__3+73+`,
	"gp__top": `SplitPayment_gp__top__NfVq-`,
	"ps": `SplitPayment_ps__-IOlC`,
	"ps__breakdown": `SplitPayment_ps__breakdown__9mn-9`,
	"ps__breakdown_sm": `SplitPayment_ps__breakdown_sm__t8V90`,
	"ps__breakdown_bdr": `SplitPayment_ps__breakdown_bdr__iUmt4`,
	"ps__breakdown_total": `SplitPayment_ps__breakdown_total__WCHld`,
	"mp": `SplitPayment_mp__U8iMg`,
	"success": `SplitPayment_success__lCsSv`,
	"simpleTable": `SplitPayment_simpleTable__3hmv+`,
	"pending": `SplitPayment_pending__BMnfH`,
	"paid": `SplitPayment_paid__yXALX`,
	"low": `SplitPayment_low__s2a-G`,
	"inStock": `SplitPayment_inStock__aStob`,
	"others": `SplitPayment_others__FIKVe`,
	"change": `SplitPayment_change__zmSbQ`,
	"action__text": `SplitPayment_action__text__BMegH`,
	"filter": `SplitPayment_filter__1blDa`,
	"filter_title": `SplitPayment_filter_title__Wg-yX`,
	"filter_group": `SplitPayment_filter_group__kaX9k`,
	"filter_item": `SplitPayment_filter_item__vuWDy`,
	"filter_selectedItem": `SplitPayment_filter_selectedItem__L7q1R`,
	"cpt": `SplitPayment_cpt__cI6xh`,
	"cpt_action": `SplitPayment_cpt_action__OaQ7e`,
	"beneficiary": `SplitPayment_beneficiary__EEqyt`,
	"beneficiary__saved": `SplitPayment_beneficiary__saved__bVbhp`,
	"beneficiary__saved_b": `SplitPayment_beneficiary__saved_b__hrsvs`,
	"beneficiary__new": `SplitPayment_beneficiary__new__N+16E`,
	"beneficiary__new_b": `SplitPayment_beneficiary__new_b__M6Nuu`,
	"unit_group": `SplitPayment_unit_group__KrtdG`,
	"unit_card": `SplitPayment_unit_card__FlVaU`,
	"searchbtnsection": `SplitPayment_searchbtnsection__O-1F5`,
	"addProduct__beside": `SplitPayment_addProduct__beside__EFcWD`,
	"addProduct__note": `SplitPayment_addProduct__note__dVfgs`,
	"addProduct__variation": `SplitPayment_addProduct__variation__f6Kni`,
	"addProduct__variation_info": `SplitPayment_addProduct__variation_info__so2Ok`,
	"addProduct__variation_info_price": `SplitPayment_addProduct__variation_info_price__vDGrc`,
	"imageUpload": `SplitPayment_imageUpload__aIzRl`,
	"lengthColor": `SplitPayment_lengthColor__bYf5I`,
	"middleButtons": `SplitPayment_middleButtons__EcI4d`,
	"selectCurrency": `SplitPayment_selectCurrency__F3q-2`,
	"selectCurrency__text": `SplitPayment_selectCurrency__text__9OkY5`,
	"selectCurrency__icon": `SplitPayment_selectCurrency__icon__jUgjy`,
	"selectCurrency__icon_active": `SplitPayment_selectCurrency__icon_active__aww82`,
	"selectCurrency__list": `SplitPayment_selectCurrency__list__DTcqk`,
	"selectCurrency__list_active": `SplitPayment_selectCurrency__list_active__tOAf5`,
	"searchContainer": `SplitPayment_searchContainer__OPjra`,
	"searchAndFilter": `SplitPayment_searchAndFilter__Fldvw`,
	"card": `SplitPayment_card__GeNLo`,
	"card_top": `SplitPayment_card_top__+Kvde`,
	"type": `SplitPayment_type__D-Lk5`,
	"type_rcb": `SplitPayment_type_rcb__ksyyI`,
	"filterClass": `SplitPayment_filterClass__DK6Nk`
};
export default ___CSS_LOADER_EXPORT___;
